import { encrypt, decrypt } from "./cipher";
import { removeTempletCache, JSONparse } from "./utils";
const storeCipher = localStorage.getItem('storeCipher') == '0' ? false : true; //加密开关
const aeskey = '4fa8959db7b4423a99f056e299914128'; //加密秘钥

/**
 * 设置本地 store
 * @param {String} key
 * @param {Object} value
 * @param {Boolean} serialize 是否开启加密，默认关闭
 */
export const setStore = (key, value, serialize = true) => {
    try {
        let infosFromLocalStorage = localStorage.getItem(key);
        value = typeof(value) === "string" ? value :JSON.stringify(value);
        if (
            infosFromLocalStorage &&
            value === localStorage.getItem(key)
        ) {
            return;
        } else {
            if (serialize && storeCipher) {
                localStorage.setItem(key, encrypt(value, aeskey));
            } else {
                localStorage.setItem(key, value);
            }
        }
    } catch (error) {
        //localStorage满了删掉第一个模板
        const templetCacheCount = removeTempletCache(1);
        templetCacheCount && setStore(key, value, serialize); // 有模板的情况下继续尝试存储
    }
};

/**
 * 获取全局 store
 * @param {String} key
 * @param {Boolean} serialize 是否开启加密，默认关闭
 */
export const getStore = (key, serialize = true) => {
    let infosFromLocalStorage = localStorage.getItem(key);
    if (infosFromLocalStorage) {
        if (serialize && storeCipher) {
            //解压出错
            try {
                return JSONparse(decrypt(infosFromLocalStorage, aeskey));
            } catch (error) {
                return JSONparse(infosFromLocalStorage);
            }
        } else {
            return JSONparse(infosFromLocalStorage);
        }
    } else {
        return null;
    }
};

//封装sessionStorage方法，增加加/解密功能
export const sessionStorageUtil = {
    //设置sessionStorage serialize：是否加密
    setItem(key, value, serialize = true) {
        if (serialize && storeCipher) {
            sessionStorage.setItem(key, encrypt(JSON.stringify(value), aeskey));
        } else {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    },
    //获取sessionStorage serialize：是否加密
    getItem(key, serialize = true) {
        let originSessionStorage = sessionStorage.getItem(key);
        if (originSessionStorage) {
            if (serialize && storeCipher) {
                try{
                    return JSON.parse(decrypt(originSessionStorage, aeskey));
                } catch (err) {
                    return JSON.parse(originSessionStorage);
                }
            } else {
                return JSON.parse(originSessionStorage);
            }
        }else{
            return null;
        }
    },
};